import { Box, Typography, Tooltip } from '@mui/material'
import { colors, typography } from '../styles/globals'
import { formatBusinessName } from '../utils/nameFormatters'

const styles = {
    businessTitle: {
        fontWeight: typography.fontWeights.semibold,
        color: colors.white,
        fontSize: typography.fontSizes.h2,

    },
    businessAddress: {
        fontWeight: typography.fontWeights.regular,
        color: colors.lightGrey,
        mb: 2,
        fontSize: typography.fontSizes.base
    }
}

const BusinessHeader = ({ name, address }) => {
    const addressName = address || "No address available"
    const formattedName = formatBusinessName(name)
    const namesAreDifferent = formattedName !== name

    const titleElement = (
        <Typography
            component="span"
            sx={{
                ...styles.businessTitle,
                cursor: namesAreDifferent ? 'help' : 'default',
            }}
        >
            {formattedName}
        </Typography>
    )

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: '100%' }}>
            <Box sx={{ display: 'inline-flex', alignSelf: 'flex-start' }}>
                {namesAreDifferent ? (
                    <Tooltip 
                        title={name} 
                        arrow
                        placement="top"
                        enterDelay={200}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    textAlign: 'center',
                                    maxWidth: 'none',
                                }
                            },
                            popper: {
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -8],
                                        },
                                    },
                                ],
                            },
                        }}
                    >
                        {titleElement}
                    </Tooltip>
                ) : (
                    titleElement
                )}
            </Box>
            <Typography
                sx={styles.businessAddress}
            >
                {addressName}
            </Typography>
        </Box>
    )
}

export default BusinessHeader